"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUCLEUS_BUSINESS_CLIENT_LAST_NAME_SENTINEL = void 0;
exports.resolveNucleusBillToName = resolveNucleusBillToName;
exports.formatNucleusPrimaryContactName = formatNucleusPrimaryContactName;
exports.resolveNucleusBillToAttn = resolveNucleusBillToAttn;
exports.resolveNucleusBillToNameFromMeta = resolveNucleusBillToNameFromMeta;
exports.resolveNucleusBillToAttnFromMeta = resolveNucleusBillToAttnFromMeta;
exports.formatNucleusClientPhone = formatNucleusClientPhone;
/** Stored on project.clientLastName when clientType is business (see FE buildClientPayload). */
exports.NUCLEUS_BUSINESS_CLIENT_LAST_NAME_SENTINEL = "(Business)";
/**
 * Single Bill-to name used by Nucleus invoice preview and PDF.
 * Order: addressedTo → companyName → person name (project first/last).
 */
function resolveNucleusBillToName(parts, fallback = "Client") {
    const addressed = String(parts.addressedTo ?? "").trim();
    if (addressed)
        return addressed;
    const company = String(parts.companyName ?? "").trim();
    if (company)
        return company;
    const first = String(parts.clientFirstName ?? "").trim();
    const last = String(parts.clientLastName ?? "").trim();
    if (last === exports.NUCLEUS_BUSINESS_CLIENT_LAST_NAME_SENTINEL) {
        if (first)
            return first;
    }
    const person = [first, last].filter(Boolean).join(" ").trim();
    if (person)
        return person;
    return fallback;
}
/**
 * Primary contact person name for a company Bill-to (not the company itself).
 * Empty when missing, sentinel, or firstName is just the company name.
 */
function formatNucleusPrimaryContactName(parts) {
    const explicit = String(parts.primaryContactName ?? "").trim();
    if (explicit)
        return explicit;
    const first = String(parts.firstName ?? "").trim();
    const last = String(parts.lastName ?? "").trim();
    if (last === exports.NUCLEUS_BUSINESS_CLIENT_LAST_NAME_SENTINEL)
        return "";
    const company = String(parts.companyName ?? "").trim();
    if (first && company && first === company)
        return "";
    return [first, last].filter(Boolean).join(" ").trim();
}
/**
 * "Attn to {name}" under company Bill-to. Empty when addressedTo overrides,
 * there is no company, or no primary contact name.
 */
function resolveNucleusBillToAttn(parts) {
    if (String(parts.addressedTo ?? "").trim())
        return "";
    const company = String(parts.companyName ?? "").trim();
    if (!company)
        return "";
    const person = formatNucleusPrimaryContactName({
        firstName: parts.clientFirstName,
        lastName: parts.clientLastName,
        companyName: company,
        primaryContactName: parts.primaryContactName,
    });
    if (!person)
        return "";
    return `Attn to ${person}`;
}
/** Read Bill-to name from project row + Nucleus project metadata (same as PDF snapshot). */
function resolveNucleusBillToNameFromMeta(project, meta, fallback = "Client") {
    return resolveNucleusBillToName(billToPartsFromMeta(project, meta), fallback);
}
/** Read Attn line from project row + Nucleus project metadata (same as PDF snapshot). */
function resolveNucleusBillToAttnFromMeta(project, meta) {
    return resolveNucleusBillToAttn(billToPartsFromMeta(project, meta));
}
function billToPartsFromMeta(project, meta) {
    return {
        addressedTo: meta?.["addressedTo"],
        companyName: meta?.["companyName"],
        primaryContactName: meta?.["primaryContactName"],
        clientFirstName: project.clientFirstName,
        clientLastName: project.clientLastName,
    };
}
/** Match PDF phone formatting: digits-only number with optional country code. */
function formatNucleusClientPhone(phoneCode, phoneNumber) {
    const num = String(phoneNumber ?? "").replace(/\D/g, "");
    if (!num)
        return "";
    const code = String(phoneCode ?? "").trim();
    return [code, num].filter(Boolean).join(" ").trim();
}
